// extracted by mini-css-extract-plugin
module.exports = {"error":"_8c650","blocks":"_90dfc","block":"_29b53","button":"_15e41","time":"fd94a","label":"_6b2d8"};